module.exports = __webpack_public_path__ + "media/files/sample_eligibility_file-cd2fb9e9d443fade3814fa174207f428.xlsx";